import { parse } from 'date-fns';

export const getAffiliatePromoCookie = (
  queryAffiliatePromo?: string,
  cookieAffiliatePromoString?: string,
  partnerPricingEnabled = false,
) => {
  if (queryAffiliatePromo && partnerPricingEnabled) {
    return {
      affiliatePromoCode: queryAffiliatePromo,
    };
  }

  if (cookieAffiliatePromoString && partnerPricingEnabled) {
    const affiliatePromoCodeMatch = cookieAffiliatePromoString?.match(/PromoCode=([^&]*)/);
    const affiliateEndDateMatch = cookieAffiliatePromoString?.match(/EndDate=([^&]*)/);

    const affiliatePromoCode = affiliatePromoCodeMatch ? affiliatePromoCodeMatch[1] : null;
    const affiliateEndDate = affiliateEndDateMatch ? affiliateEndDateMatch[1] : null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isAffiliateEndDateValid = affiliateEndDate
      ? parse(affiliateEndDate, 'dd/MM/yyyy', new Date()) >= today
      : false;

    return {
      affiliatePromoCode: isAffiliateEndDateValid ? affiliatePromoCode : undefined,
    };
  }

  return {
    affiliatePromoCode: undefined,
  };
};
